module.exports = __webpack_public_path__ + "files/aeaf05c9c3435e7f45e84ba11fb9bd57.png";